import apiClient from './apiClient';

// Helper to ensure localStorage is saved before continuing
const saveToLocalStorage = (token, user) => {
  return new Promise((resolve) => {
    console.log('[AUTH] Saving token to localStorage...');
    console.log('[AUTH] Token to save:', token ? token.substring(0, 20) + '...' : 'NONE');
    
    localStorage.setItem('session_token', token);
    localStorage.setItem('user', JSON.stringify(user));
    
    // Verify it was saved
    setTimeout(() => {
      const savedToken = localStorage.getItem('session_token');
      console.log('[AUTH] Token saved successfully:', !!savedToken);
      console.log('[AUTH] Saved token value:', savedToken ? savedToken.substring(0, 20) + '...' : 'NONE');
      resolve();
    }, 100);
  });
};

// Authentication
export const login = async (username, password) => {
  console.log('[AUTH] Login attempt for:', username);
  const response = await apiClient.post('/auth/login', { username, password });
  console.log('[AUTH] Login response received');
  console.log('[AUTH] Session token in response:', response.data.session_token ? 'YES' : 'NO');
  
  // Save token to localStorage and wait for it
  if (response.data.session_token) {
    await saveToLocalStorage(response.data.session_token, response.data.user);
  } else {
    console.error('[AUTH] No session_token in login response!');
  }
  return response.data;
};

export const googleCallback = async (sessionId) => {
  console.log('[AUTH] Google callback with session:', sessionId);
  const response = await apiClient.post(`/auth/google/callback?session_id=${sessionId}`);
  console.log('[AUTH] Google callback response received');
  
  // Save token to localStorage and wait for it
  if (response.data.session_token) {
    await saveToLocalStorage(response.data.session_token, response.data.user);
  } else {
    console.error('[AUTH] No session_token in Google callback response!');
  }
  return response.data;
};

export const getMe = async () => {
  const response = await apiClient.get('/auth/me');
  return response.data;
};

export const logout = async () => {
  // Clear localStorage first
  localStorage.removeItem('session_token');
  localStorage.removeItem('user');
  
  try {
    const response = await apiClient.post('/auth/logout');
    return response.data;
  } catch (error) {
    // Even if logout fails, we've cleared local storage
    return { success: true };
  }
};

// Admin - User Management
export const getUsers = async () => {
  const response = await apiClient.get('/admin/users');
  return response.data;
};

export const createUser = async (userData) => {
  const response = await apiClient.post('/admin/users', userData);
  return response.data;
};

export const updateUser = async (userId, userData) => {
  const response = await apiClient.put(`/admin/users/${userId}`, userData);
  return response.data;
};

export const deleteUser = async (userId) => {
  const response = await apiClient.delete(`/admin/users/${userId}`);
  return response.data;
};

export const toggleUserStatus = async (userId, status) => {
  const response = await apiClient.patch(`/admin/users/${userId}/status?status=${status}`);
  return response.data;
};

export const getRoles = async () => {
  const response = await apiClient.get('/admin/roles');
  return response.data;
};

export const getSites = async () => {
  const response = await apiClient.get('/admin/sites');
  return response.data;
};

export const getSitesRegistry = async () => {
  /** Multi-tenant sites (Salem + provisioned sites) — used for tenant assignment in User Management. */
  const response = await apiClient.get('/sites-registry/admin');
  return response.data;
};

export const getSections = async () => {
  const response = await apiClient.get('/admin/sections');
  return response.data;
};

export const getStaffSections = async () => {
  const response = await apiClient.get('/admin/staff-sections');
  return response.data;
};

export const getModules = async () => {
  const response = await apiClient.get('/admin/modules');
  return response.data;
};

// Imports
export const importRoles = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await apiClient.post('/imports/roles', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const importSites = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await apiClient.post('/imports/sites', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const getImportLogs = async () => {
  const response = await apiClient.get('/imports/import-logs');
  return response.data;
};
